import React, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import DropDownTable from '../../Shared/DropDownTable';
import UploadFile from '../../Shared/UploadFile';
import Input from '../../Shared/Input';
import '../../../css/GenericServices/UpdateResponseForm.css';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import uparrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import downarrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import calender from '../../../Assets/ProfileManagement/Assets-Desktop/calender.svg';
import { masterJson } from '../../../Data/GenericServices/updateResponseFormData';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL, servicecatalogBaseURL } from '../../../Services/config/apiGateway';
import { SERVICE_REQUEST_ENDPOINT, uiFieldsMetaData_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { FormatTimeStamp } from '../../../Services/utils/FormatTimeStamp';
const ViewServiceDetailsGS = (props) => {
    const container = React.createRef();
    const [errors, setErrors] = useState({});
    const [editableMode, setEditTable] = useState(false);
    const [filePathRefDoc, setFilepathRefDoc] = useState('');
    const [loaderTime, setLoaderTime] = useState('')
    const [pageDisable, setPageDisable] = useState('');
    const [commodityDropDown, setCommodityDropDown] = useState([]);
    const [textLength, setTextLength] = useState([]);
    const [Commoditydata, setCommoditydata] = useState([{ name: "Bulk Bags" }, { name: "Bulk Cargo" }, { name: "Bundled Steel/Timber" }])
    const [CommoditydataValues, setCommoditydataValues] = useState([{ name: "ABC" }, { name: "XYZ" }, { name: "ABCD" }])
    const [values, setValues] = useState([]);
    const [filterJson, setFilterJson] = useState([]);
    const [calendarDate, setCalendarDate] = useState([]);
    const [calendarHour, setCalendarHour] = useState([]);
    const [calendarMin, setCalendarMin] = useState([]);
    const [dateToggle, setDateToggle] = useState([]);
    const [hourToggle, setHourToggle] = useState([]);
    const [minToggle, setMinToggle] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [paymentTerm , setPaymentTerm] = useState('');
    const [rfqDate, setRfqDate] = useState('');
    const hourValues = [{ hour: "00" }, { hour: "01" }, { hour: "02" }, { hour: "03" }, { hour: "04" }, { hour: "05" }, { hour: "06" }, { hour: "07" }, { hour: "08" }, { hour: "09" },
    { hour: "10" }, { hour: "11" }, { hour: "12" }, { hour: "13" }, { hour: "14" }, { hour: "15" }, { hour: "16" }, { hour: "17" }, { hour: "18" }, { hour: "19" },
    { hour: "20" }, { hour: "21" }, { hour: "22" }, { hour: "23" }];
    const minValues = [{ minit: "00" }, { minit: "01" }, { minit: "02" }, { minit: "03" }, { minit: "04" }, { minit: "05" }, { minit: "06" }, { minit: "07" }, { minit: "08" }, { minit: "09" },
    { minit: "10" }, { minit: "11" }, { minit: "12" }, { minit: "13" }, { minit: "14" }, { minit: "15" }, { minit: "16" }, { minit: "17" }, { minit: "18" }, { minit: "19" },
    { minit: "20" }, { minit: "21" }, { minit: "22" }, { minit: "23" }, { minit: "24" }, { minit: "25" }, { minit: "26" }, { minit: "27" }, { minit: "28" }, { minit: "29" },
    { minit: "30" }, { minit: "31" }, { minit: "32" }, { minit: "33" }, { minit: "34" }, { minit: "35" }, { minit: "36" }, { minit: "37" }, { minit: "38" }, { minit: "39" },
    { minit: "40" }, { minit: "41" }, { minit: "42" }, { minit: "43" }, { minit: "44" }, { minit: "45" }, { minit: "46" }, { minit: "47" }, { minit: "48" }, { minit: "49" },
    { minit: "50" }, { minit: "51" }, { minit: "52" }, { minit: "53" }, { minit: "54" }, { minit: "55" }, { minit: "56" }, { minit: "57" }, { minit: "58" }, { minit: "59" }];
    var getDataBody = {
    }
    const getDateFormated = (timeStamp) => {
        let date = new Date(Number(timeStamp)).toString();
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        return `${day}-${month}-${year}`;
    }
    const getTimeFormated = (timeStamp) => {
        if (timeStamp) {
            return new Date(Number(timeStamp)).toGMTString().split(' ')[4].substring(0, 5)
        }
    }
    var allData = {};
    useEffect(() => {
        const serviceName = props.name;
        if (props.data) {
            getDataBody = props.data?.serviceRequestData;
            allData = props.data;
        }
        console.log('Hiii service name', serviceName);
        console.log('Hiii allData', allData);
        setStartDate(allData?.requestSummary?.serviceDetail?.startDateTime);
        setEndDate(allData?.requestSummary?.serviceDetail?.endDateTime);
        setRfqDate(allData?.requestSummary?.serviceDetail?.rfqDateTime);
        setPaymentTerm(allData?.requestSummary?.serviceDetail?.paymentTerm)
        var serviceNameType = serviceName.replace("&", "%26");
        ApiCall(
            'GET',
            servicecatalogBaseURL + uiFieldsMetaData_ENDPOINT + `?serviceName=${serviceNameType}`,
            {},
            {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        ).then((apiData) => {
            if (apiData.flag != -1) {
                if (apiData.flag == 500) {
                    console.log('I am 500!');
                }
                else {
                    console.log('I am 200!');
                    let temp = [];
                    let dropv = [];
                    let fieldNameTemp1 = '';
                    apiData?.find((x, i) => {
                        masterJson.forEach((data, index) => {
                            if (data.fieldId == x.fieldId) {
                                fieldNameTemp1 = x.fieldName;
                                Object.keys(getDataBody)?.map((name, index1) => {
                                    let val1 = Object.values(getDataBody)[index1];
                                    if (name == fieldNameTemp1 && val1) {
                                        temp.push({
                                            fieldId: x.fieldId,
                                            fieldName: x.fieldName,
                                            displayName: x.displayName,
                                            inputType: data.inputType,
                                            dropDownData: data.dropDownData,
                                            validationType: data.validationType,
                                            requiredField: data.requiredField,
                                            isEdit: data.isEdit
                                        })
                                    }
                                })
                                dropv.push(false);
                            }
                        })
                    })
                    setFilterJson(temp);
                    // setValues(val);
                    setCommodityDropDown(dropv);
                    let fieldNameTemp = '';
                    let getDetails = [];
                    for (let index = 0; index < temp.length; index++) {
                        fieldNameTemp = temp[index].fieldName;
                        Object.keys(getDataBody)?.map((name, i) => {
                            if (name == fieldNameTemp) {
                                let val1 = Object.values(getDataBody)[i];
                                if (temp[index].inputType == 'calendarDate') {
                                    // val1 = getDateFormated(val1);
                                    calendarDate[index] = getDateFormated(val1);
                                    setCalendarDate(calendarDate);
                                }
                                else if (temp[index].inputType == 'calendarDateTime') {
                                    calendarDate[index] = getDateFormated(val1);
                                    setCalendarDate(calendarDate);
                                    calendarHour[index] = getTimeFormated(val1).split(':')[0];
                                    setCalendarHour(calendarHour);
                                    calendarMin[index] = getTimeFormated(val1).split(':')[1];
                                    setCalendarMin(calendarMin);
                                    //val1 = getDateFormated(val1) + ' ' + getTimeFormated(val1);
                                }
                                getDetails.push(val1);
                            }
                        });
                        console.log('abc--', Object.values(getDataBody)[0]);
                    }
                    setValues(getDetails);
                    console.log('getData', getDetails);
                }
            }
        });
    }, [])
    const changeFormMode = () => {
        setEditTable(true);
    }
    const postCall = () => {
        const tempData = [];
        const obj = {};
        for (let index = 0; index < filterJson.length; index++) {
            const element = values[index];
            const fieldNameTempp = filterJson[index].fieldName;
            obj[fieldNameTempp] = element;
        }
        tempData.push(obj);
        console.log('temp', tempData);
        console.log('commodity', tempData[0]?.commodity);
        console.log('temperature_range', tempData[0]?.temperature_range);
        console.log('comments', tempData[0]?.comments);
        console.log('container_no', tempData[0]?.container_no);
        console.log('container_size', tempData[0]?.container_size);
    }
    const handleChangeInput = (e, index, displayName) => {
        if (filterJson[index].inputType == 'inputWithLimit' && e.target.value.length <= 500) {
            textLength[index] = e.target.value.length;
            setTextLength(textLength);
            console.log('err text', textLength);
            values[index] = e.target.value;
            setValues(values);
            let var1 = errors[displayName] = '';
            console.log('error-', errors);
            setErrors({ ...errors, var1 })
            document.getElementsByName(displayName)[0].style.borderColor = ColorCode.colorCode.black;
        } else {
            console.log('err displa', displayName);
            values[index] = e.target.value;
            setValues(values);
            let var1 = errors[displayName] = '';
            console.log('error-', errors);
            setErrors({ ...errors, var1 })
            document.getElementsByName(displayName)[0].style.borderColor = ColorCode.colorCode.black;
        }
    }
    const validate = () => {
        let errors = {};
        let formIsValid = true;
        var patternCharacter = new RegExp(/^[a-zA-Z ]*$/);
        var patternDigit = new RegExp(/^[0-9\b]+$/);
        var patternAlphaNumeric = new RegExp(/^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]+$/);
        for (let index = 0; index < filterJson.length; index++) {
            if (filterJson[index].isEdit && editableMode) {
                const element = values[index];
                if (!element && filterJson[index].requiredField == 'yes') {
                    formIsValid = false;
                    errors[filterJson[index].displayName] = Message.validation.required;
                    document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.red;
                } else if (element && !patternCharacter.test(element) && filterJson[index].validationType == 'alpha') {
                    formIsValid = false;
                    errors[filterJson[index].displayName] = Message.validation.alpha;
                    document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.red;
                } else if (element && !patternDigit.test(element) && filterJson[index].validationType == 'num') {
                    formIsValid = false;
                    errors[filterJson[index].displayName] = Message.validation.num;
                    document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.red;
                } else if (element && !patternAlphaNumeric.test(element) && filterJson[index].validationType == 'alphanum') {
                    formIsValid = false;
                    errors[filterJson[index].displayName] = Message.validation.alphanum;
                    document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.red;
                } else {
                    document.getElementsByName(filterJson[index].displayName)[0].style.borderColor = ColorCode.colorCode.black;
                }
                //upload file border only
                if (filterJson[index].inputType == 'upload' && !element && filterJson[index].requiredField == 'yes') {
                    document.getElementById(filterJson[index].displayName).style.borderColor = ColorCode.colorCode.red;
                }
                else if (filterJson[index].inputType == 'upload' && element) {
                    document.getElementById(filterJson[index].displayName).style.borderColor = ColorCode.colorCode.black;
                }
                // calender time and min border only
                if (filterJson[index].inputType == 'calendarDateTime' && !element && filterJson[index].requiredField == 'yes') {
                    document.getElementsByName(filterJson[index].fieldName)[0].style.borderColor = ColorCode.colorCode.red;
                } else if (filterJson[index].inputType == 'calendarDateTime' && element) {
                    document.getElementsByName(filterJson[index].fieldName)[0].style.borderColor = ColorCode.colorCode.black;
                }
            }
        }
        setErrors(errors);
        return formIsValid;
    }
    const toggleDropDown = (index) => {
        const element = commodityDropDown[index];
        let var2 = !element;
        commodityDropDown[index] = !element;
        console.log('dropdown', index, commodityDropDown);
        setCommodityDropDown({ ...commodityDropDown, var2 });
    };
    const toggleDate = (index) => {
        const element = dateToggle[index];
        let var2 = !element;
        dateToggle[index] = !element;
        console.log('dropdown', index, dateToggle);
        setDateToggle({ ...dateToggle, var2 });
    }
    const toggleHour = (index) => {
        const element = hourToggle[index];
        let var2 = !element;
        hourToggle[index] = !element;
        console.log('dropdown', index, hourToggle);
        setHourToggle({ ...hourToggle, var2 });
    }
    const toggleMin = (index) => {
        const element = minToggle[index];
        let var2 = !element;
        minToggle[index] = !element;
        console.log('dropdown', index, minToggle);
        setMinToggle({ ...minToggle, var2 });
    }
    const onSubmit = () => {
        console.log('before validate-', values);
        for (let index = 0; index < filterJson.length; index++) {
            if (filterJson[index].inputType == 'calendarDateTime') {
                let fromTimeStamp = new Date(calendarDate[index]).toString().substring(4, 15) + ' '
                    + calendarHour[index] + ':' + calendarMin[index];
                values[index] = Date.parse(fromTimeStamp);
                setValues(values);
            } else if (filterJson[index].inputType == 'calendarDate') {
                let fromTimeStamp = new Date(calendarDate[index]).toString().substring(4, 15);
                values[index] = Date.parse(fromTimeStamp);
                setValues(values);
            }
        }
        console.log('validate-', values);
        if (validate()) {
            console.log('submit val-', values);
            alert('success');
            postCall();
        }
    }
    const changeDropDownValue = (e, index) => {
        const found = filterJson[index].dropDownData?.find((name) => {
            if (name.name === e.target.innerText) {
                return name
            }
        })
        values[index] = found.name;
        setValues(values);
        const element = commodityDropDown[index];
        let var2 = !element;
        commodityDropDown[index] = !element;
        console.log('dropdown', index, commodityDropDown);
        setCommodityDropDown({ ...commodityDropDown, var2 });
        console.log('val--', values)
        let displayName = filterJson[index].displayName;
        let var1 = errors[displayName] = '';
        console.log('error-', errors);
        setErrors({ ...errors, var1 })
        document.getElementsByName(displayName)[0].style.borderColor = ColorCode.colorCode.black;
    }
    const removeUpdateReferenceDocumentsLink = () => {
        let path = "";
        setFilepathRefDoc(path);
    }
    const setUploadLinkUpdateReferenceDocuments = (filePathURL) => {
        for (let index = 0; index < filterJson.length; index++) {
            if (filterJson[index].inputType == 'upload') {
                values[index] = filePathURL;
                setValues(values);
            }
        }
        setFilepathRefDoc(filePathURL);
        setLoaderTime(false);
        setPageDisable(false);
    }
    const setLoaderUpdateReferenceDocuments = (filePathURL) => {
        setLoaderTime(filePathURL);
        setPageDisable(filePathURL);
    }
    const handleChangeDate = (e, index) => {
        calendarDate[index] = getDateFormated(e);
        setCalendarDate(calendarDate);
        console.log('cale--', calendarDate);
        const element = dateToggle[index];
        let var2 = !element;
        dateToggle[index] = !element;
        console.log('dropdown', index, dateToggle);
        setDateToggle({ ...dateToggle, var2 });
        let displayNameTemp = filterJson[index].displayName;
        let var1 = errors[displayNameTemp] = '';
        console.log('error-', errors);
        setErrors({ ...errors, var1 })
        document.getElementsByName(displayNameTemp)[0].style.borderColor = ColorCode.colorCode.black;
        //change min and hour boder
        if (filterJson[index].inputType == 'calendarDateTime') {
            let fieldNameTemp = filterJson[index].fieldName;
            document.getElementsByName(fieldNameTemp)[0].style.borderColor = ColorCode.colorCode.black;
        }
    }
    const handleChangeHour = (e, index) => {
        const found = hourValues.find((name) => {
            if (name.hour === e.target.innerText) {
                return name
            }
        })
        calendarHour[index] = found.hour;
        setCalendarHour(calendarHour);
        console.log('hour', calendarHour)
        const element = hourToggle[index];
        let var2 = !element;
        hourToggle[index] = !element;
        console.log('dropdown', index, hourToggle);
        setHourToggle({ ...hourToggle, var2 });
        let fieldNameTemp = filterJson[index].fieldName;
        let displayNameTemp = filterJson[index].displayName;
        let var1 = errors[displayNameTemp] = '';
        console.log('error-', errors);
        setErrors({ ...errors, var1 })
        document.getElementsByName(fieldNameTemp)[0].style.borderColor = ColorCode.colorCode.black;
        //change calender date border
        document.getElementsByName(displayNameTemp)[0].style.borderColor = ColorCode.colorCode.black;
    }
    const handleChangeMin = (e, index) => {
        const found = minValues.find((name) => {
            if (name.minit === e.target.innerText) {
                return name
            }
        })
        calendarMin[index] = found.minit;
        setCalendarMin(calendarMin);
        const element = minToggle[index];
        let var2 = !element;
        minToggle[index] = !element;
        console.log('dropdown', index, minToggle);
        setMinToggle({ ...minToggle, var2 });
        let fieldNameTemp = filterJson[index].fieldName;
        let displayNameTemp = filterJson[index].displayName;
        let var1 = errors[displayNameTemp] = '';
        console.log('error-', errors);
        setErrors({ ...errors, var1 })
        document.getElementsByName(fieldNameTemp)[0].style.borderColor = ColorCode.colorCode.black;
        //change calender date border
        document.getElementsByName(displayNameTemp)[0].style.borderColor = ColorCode.colorCode.black;
    }
    return (
        <div class="UpdateResponseFormCardcss">
            {/* <div class="UpdateResponseFormInpSize">
                <small id="UpdateResponseFormInpHeading">Service Window Start Date & Time</small>
                <div class="UpdateResponseFormRLowerText">{FormatTimeStamp(startDate).timedateToLocale}</div>
            </div>
            <div class="UpdateResponseFormInpSize">
                <small id="UpdateResponseFormInpHeading">Service Window End Date & Time</small>
                <div class="UpdateResponseFormRLowerText">{FormatTimeStamp(endDate).timedateToLocale}</div>
            </div>
            <div class="UpdateResponseFormInpSize">
                <small id="UpdateResponseFormInpHeading">Request Closing Date</small>
                <div class="UpdateResponseFormRLowerText">{FormatTimeStamp(rfqDate).timedateToLocale}</div>
            </div> */}
            {filterJson.map((name, index) => {
                return (
                    <>
                        {(name.inputType == 'input' || name.inputType == 'inputWithLimit') &&
                            <div class="UpdateResponseFormInpSize">
                                <small id="UpdateResponseFormInpHeading">{name.displayName}</small>
                                {(name.isEdit && editableMode) ?
                                    <div className="pass-wrapper" id="UpdateResponseFormInpDiv" >
                                        <Input
                                            name={name.displayName}
                                            class="input" placeholder={`Enter ${name.displayName}`}
                                            type="text" id="UpdateResponseFormInpCss" value={values[index]}
                                            onChange={(e) => handleChangeInput(e, index, name.displayName)}
                                        />
                                        <div className="UpdateResponseFormError">{errors[name.displayName]}</div>
                                        {name.inputType == 'inputWithLimit' &&
                                            <small class="UpdateResponseFormCommentTextlmt">{textLength[index] ? textLength[index] : 0}/500</small>
                                        }
                                    </div>
                                    :
                                    <div class="UpdateResponseFormRLowerText">{values[index]} </div>
                                }
                            </div>
                        }
                        {name.inputType == 'dropdown' &&
                            <div class="UpdateResponseFormInpSize">
                                <small id="UpdateResponseFormInpHeading">{name.displayName}</small>
                                {(name.isEdit && editableMode) ?
                                    <div className="pass-wrapper" id="UpdateResponseFormInpDiv" >
                                        <Input
                                            readOnly
                                            name={name.displayName} class="input" placeholder={`Select ${name.displayName}`}
                                            type="text" id={commodityDropDown[index] ? "UpdateResponseFormBtmBorderLessCss" : "UpdateResponseFormInpDropCss"}
                                            value={values[index]}
                                        />
                                        <div className="UpdateResponseFormError">{errors[name.displayName]}</div>
                                        <i id="UpdateResponseFormInp_imgDrop" onClick={() => toggleDropDown(index)}>
                                            <img src={commodityDropDown[index] ? uparrow : downarrow} />
                                        </i>
                                    </div>
                                    :
                                    <div class="UpdateResponseFormRLowerText">{values[index]} </div>
                                }
                                {commodityDropDown[index] && (
                                    <div class="UpdateResponseFormDropDowmDiv" >
                                        <div class="UpdateResponseFormDropCard" ref={container} >
                                            {(name.dropDownData?.map((data, i) => {
                                                return (
                                                    <DropDownTable id="UpdateResponseFormDropRowSize" onClick={(e) => changeDropDownValue(e, index)}>
                                                        <small class="" id="UpdateResponseFormDropRowText" >{data.name} </small>
                                                    </DropDownTable>
                                                );
                                            }))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        }
                        {name.inputType == 'upload' &&
                            <div class="UpdateResponseFormInpSize">
                                <small id="UpdateResponseFormInpHeading">{name.displayName}</small>
                                {(name.isEdit && editableMode) ?
                                    <div className="pass-wrapper" id="UpdateResponseFormInpDiv" >
                                        <UploadFile uploaddivid={name.displayName} idupload="upload"
                                            name={name.displayName}
                                            fileType="jpeg, jpg, png, pdf"
                                            removeLink={removeUpdateReferenceDocumentsLink}
                                            upload_link="cipcUpload" uploadicon="cipcIcon"
                                            setFileLink={setUploadLinkUpdateReferenceDocuments}
                                            setLoader={setLoaderUpdateReferenceDocuments}
                                            staticFileName={'Update_Reference_Documents.'}
                                        />
                                        <div className="UpdateResponseFormError">{errors[name.displayName]}</div>
                                    </div>
                                    :
                                    <div class="UpdateResponseFormRLowerText">{values[index]?.split('/')[11].split("'")[0]} </div>
                                }
                            </div>
                        }
                        {(name.inputType == 'calendarDateTime' || name.inputType == 'calendarDate') &&
                            <div class="UpdateResponseFormInpSize">
                                <small id="UpdateResponseFormInpHeading">{name.displayName}</small>
                                {(name.isEdit && editableMode) ?
                                    <div id="UpdateResponseFormCalOuterDiv">
                                        <div className="pass-wrapper" id="UpdateResponseFormCalendarDiv">
                                            <input
                                                readOnly
                                                class="inpuut1"
                                                placeholder="Select Date"
                                                type="text"
                                                id="UpdateResponseFormCalSWCss"
                                                name={name.displayName}
                                                autoComplete="off"
                                                value={calendarDate[index]}
                                            />
                                            <div className="UpdateResponseFormDropError">{errors[name.displayName]}</div>
                                            <div class="UpdateResponseFormSWCalendarWidth">  {dateToggle[index] ?
                                                <div ref={container}>
                                                    <Calendar onChange={(e) => handleChangeDate(e, index)} />
                                                </div> : null}
                                            </div>
                                            <img id="UpdateResponseFormSWCal_imgCal" src={calender} alt="" onClick={() => toggleDate(index)}
                                            />
                                        </div>
                                        {name.inputType == 'calendarDateTime' &&
                                            <div id={hourToggle[index] ? "UpdateResponseFormHourDiv" : (minToggle[index] ? "UpdateResponseFormMinitDiv" : "UpdateResponseFormHTDiv")} name={name.fieldName}>
                                                <div id="UpdateResponseFormHHDiv" >
                                                    <div className="pass-wrapper" id="UpdateResponseFormInpDiv" >
                                                        <Input
                                                            readOnly name="SWStartHour" class="" placeholder="HH"
                                                            type="text" id="UpdateResponseFormHTDropCss"
                                                            value={calendarHour[index]}
                                                        />
                                                        <i id="UpdateResponseFormHHMM_imgDrop" onClick={() => toggleHour(index)}>
                                                            {hourToggle[index] ? <img src={uparrow} /> : <img src={downarrow} />}
                                                        </i>
                                                    </div>
                                                    {hourToggle[index] && (
                                                        <div class="UpdateResponseFormDropDowmDiv" >
                                                            <div class="UpdateResponseFormHMDropCard" ref={container} >
                                                                {(hourValues?.map((name, i) => {
                                                                    return (
                                                                        <DropDownTable onClick={(e) => handleChangeHour(e, index)} id="UpdateResponseFormHHMMRowSize">
                                                                            <small class="" id="UpdateResponseFormDropRowText" >{name.hour} </small>
                                                                        </DropDownTable>
                                                                    );
                                                                }))}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <div id="UpdateResponseFormTTDiv">
                                                    <div className="pass-wrapper" id="UpdateResponseFormInpDiv" >
                                                        <Input
                                                            readOnly name="SWStartMinit" class="" placeholder="MM"
                                                            type="text" id="UpdateResponseFormHTDropCss"
                                                            value={calendarMin[index]}
                                                        />
                                                        <i id="UpdateResponseFormMinit_imgDrop" onClick={() => toggleMin(index)}>
                                                            {minToggle[index] ? <img src={uparrow} /> : <img src={downarrow} />}
                                                        </i>
                                                    </div>
                                                    {minToggle[index] && (
                                                        <div class="UpdateResponseFormDropDowmDiv" >
                                                            <div class="UpdateResponseFormHMDropCard" ref={container} >
                                                                {(minValues.map((name, i) => {
                                                                    return (
                                                                        <DropDownTable onClick={(e) => handleChangeMin(e, index)} id="UpdateResponseFormHHMMRowSize">
                                                                            <small class="" id="UpdateResponseFormDropRowText" >{name.minit} </small>
                                                                        </DropDownTable>
                                                                    );
                                                                }))}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    :
                                    name.inputType == 'calendarDateTime' ?
                                        <div class="UpdateResponseFormRLowerText">{calendarDate[index]} {calendarHour[index]}:{calendarMin[index]}</div>
                                        :
                                        <div class="UpdateResponseFormRLowerText">{calendarDate[index]} </div>
                                }
                            </div>
                        }
                    </>
                )
            })
            }
              <div class="UpdateResponseFormInpSize">
                <small id="UpdateResponseFormInpHeading">Service Window Start Date & Time</small>
                <div class="UpdateResponseFormRLowerText">{FormatTimeStamp(startDate).timedateToLocale}</div>
            </div>
            <div class="UpdateResponseFormInpSize">
                <small id="UpdateResponseFormInpHeading">Service Window End Date & Time</small>
                <div class="UpdateResponseFormRLowerText">{FormatTimeStamp(endDate).timedateToLocale}</div>
            </div>
            <div class="UpdateResponseFormInpSize">
                <small id="UpdateResponseFormInpHeading">Request Closing Date</small>
                <div class="UpdateResponseFormRLowerText">{FormatTimeStamp(rfqDate).timedateToLocale}</div>
            </div>
            <div class="UpdateResponseFormInpSize">
                <small id="UpdateResponseFormInpHeading">Payment Terms</small>
                <div class="UpdateResponseFormRLowerText">{paymentTerm}</div>
            </div>
        </div>
    )
}
export default ViewServiceDetailsGS;